import React from "react";
import { WbsConfiguration } from "@planzone/dto";
import { Props } from "./types";

const Context = React.createContext<{
  configuration?: WbsConfiguration[number]["columns"];
  style: Props["style"];
}>({
  configuration: [],
  style: {},
});

export { Context };
